import { ChevronRightIcon } from '@heroicons/react/20/solid';

export const DocumentLine = ({href, label}) => 
<li >
    <a href={href} target="_blank" className="block hover:bg-gray-50">
        <div className="flex items-center px-4 py-4 sm:px-6">
            <div className="flex min-w-0 flex-1 items-center">
                <div className="flex-shrink-0">
                    <i className="fa fa-download" aria-hidden="true"/>
                </div>
                <div className="min-w-0 flex-1 px-4 md:grid md:grid-cols-2 md:gap-4">
                    <div>
                        <p className="truncate text-sm font-medium text-orange-600 hover:text-orange-700">{label}</p>
                    </div>
                </div>
            </div>
            <div>
                <ChevronRightIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
            </div>
        </div>
    </a>
</li>